import axios from "axios";
import router from "../router";
import Swal from "sweetalert2";

import {
    apiURL,
    devOpsURL,
    statisticsURL,
    apiJavaURL,
    localStorageKey,
    videoEncodeApi,
    statisticsJavaURL
} from "./config";
import EventBus from "@/utils/event-bus";
import {clearSession, getIsSessionInvalidated, logout} from "@/utils/logout";
import moment from 'moment';

let isOtherPlatformLogoutAlertOpen = false;
const stopHandledResponseFlow = new Promise(() => {});

const stopGlobalLoading = () => {
    EventBus.$emit("changeLoading", false);
    EventBus.$emit("changeStyleLoading", false);
    EventBus.$emit("apiLoading", false);
    EventBus.$emit("resetLogoutTimer", false);
};

const logApiError = (error) => {
    const response = error?.response;
    const config = error?.config;

    console.error('API ERROR', {
        url: config?.url,
        method: config?.method,
        status: response?.status,
        data: response?.data,
        message: error?.message,
        code: error?.code,
    });
};

const handleOtherPlatformLogout = () => {
    if (isOtherPlatformLogoutAlertOpen) {
        return true;
    }

    isOtherPlatformLogoutAlertOpen = true;
    clearSession();
    stopGlobalLoading();
    Swal.close();
    Swal.fire({
        title: '',
        html: '현재 계정의 다른 플랫폼 로그아웃으로 인하여<br>다시 로그인이 필요합니다.',
        confirmButtonText: '닫기',
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'rainbow-default',
    }).then(() => {
        isOtherPlatformLogoutAlertOpen = false;
        location.href = '/onboard';
    });

    return true;
};

const handleCommonApiCode = (data) => {
    if (getIsSessionInvalidated()) {
        return true;
    }

    if (!data || typeof data.code === "undefined" || data.code === null) {
        return false;
    }

    if (Number(data.code) === -672) {
        return handleOtherPlatformLogout();
    }

    return false;
};

const resolveCommonApiResponse = (response) => {
    if (handleCommonApiCode(response?.data)) {
        return stopHandledResponseFlow;
    }

    return response;
};

const resolveCommonApiError = (response) => {
    if (getIsSessionInvalidated()) {
        stopGlobalLoading();
        return stopHandledResponseFlow;
    }

    if (handleCommonApiCode(response?.data)) {
        return stopHandledResponseFlow;
    }

    return response;
};

const onUnauthorized = () => {
    if (getIsSessionInvalidated()) {
        stopGlobalLoading();
        return stopHandledResponseFlow;
    }

    logout();
};

const RESULTCODE = {
    INVALIDE_PARAMETER: "INVALID_PARAMETER",
    SUCCEEDED: "SUCCEEDED",
    ERROR: "ERROR",
};
const RESULTDEFUALTDATA = {data: {Data: {Result: {Info: {status: false, type: null}}}}}

const getResultDefaultData = (type) => {
    let result = Object.assign({}, RESULTDEFUALTDATA)
    result.data.Data.Result.Info.type = type;
    return result;
}
export const setAuthInHeader = token => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
};
export const removeAuthInHeader = () => {
    delete axios.defaults.headers.common['Authorization'];
};

export const request = {
    javaGet(path, params = null, config = {}) {
        return axios.get(`${apiJavaURL + path}`, {...config, params})
            .then(res => {
                const handledResponse = resolveCommonApiResponse(res);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해 주세요.");
                    router.push("/");
                    return res;
                } else return res;
            }).catch(({response}) => {
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                return response
            })
    },
    javaPost(path, data, config = {}) {
        return axios.post(`${apiJavaURL + path}`, data, config)
            .then(res => {
                const handledResponse = resolveCommonApiResponse(res);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch((error) => {
                const {response} = error;
                if (response == undefined) {
                    logApiError(error);
                    return response
                }
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                const {status} = response.data.code;

                if (response == undefined || status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaDelete(path, params = null, config = {}) {
        return axios.delete(`${apiJavaURL + path}`, {...config, data: params})
            .then(res => {
                return resolveCommonApiResponse(res);
            }).catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaPut(path, data, config = {}) {
        return axios.put(`${apiJavaURL + path}`, data, config)
            .then(res => {
                return resolveCommonApiResponse(res);
            }).catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaPatch(path, data, config = {}) {
        return axios.patch(`${apiJavaURL + path}`, data, config)
            .then(res => {
                return resolveCommonApiResponse(res);
            }).catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203 || status === 401) {
                    return onUnauthorized();
                }
                return response
            })
    },

    // get(path, params = null) {
    //
    //     return axios.get(`${apiURL + path}`, {params: params})
    //         .then(res => {
    //             if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
    //                 alert("문제가 발생했습니다. 다시 시도해 주세요.");
    //                 router.push("/");
    //                 return res;
    //             } else return res;
    //         }).catch(({response}) => {
    //             // router.push("/");
    //             const {status} = response;
    //             if (status === 401) {
    //                 return onUnauthorized();
    //             } else if (status === 'Errored') {
    //                 alert("잘못된 정보입니다.");
    //             }
    //             throw Error(response)
    //         })
    // },
    // post(path, data) {
    //     return axios
    //         .post(`${apiURL + path}`, data)
    //         .then((res) => {
    //             if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
    //                 alert("문제가 발생했습니다. 다시 시도해 주세요.");
    //                 EventBus.$emit("changeStyleLoading", false);
    //                 router.push("/");
    //                 return res;
    //             } else {
    //                 if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
    //                     logout();
    //                 } else {
    //                     return res;
    //                 }
    //             }
    //         })
    //         .catch((response) => {
    //             EventBus.$emit("changeStyleLoading", false);
    //             router.push("/");
    //             const {status} = response || {status: null};
    //             if (status === 401) {
    //                 return onUnauthorized();
    //             } else if (status === 'Errored') {
    //                 alert("잘못된 정보입니다.");
    //             }
    //             throw Error(response);
    //         });
    // },
    snsPost(path, data) {
        return axios
            .post(`${apiURL + path}`, data)
            .then((res) => {
                const handledResponse = resolveCommonApiResponse(res);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    EventBus.$emit("changeStyleLoading", false);
                    return res;
                } else {
                    return res;
                }
            })
            .catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                EventBus.$emit("changeStyleLoading", false);

                throw Error(response);
            });
    },

    devOpsPost(path, data) {
        return axios
            .post(`${devOpsURL + path}`, data)
            .then((res) => {
                const handledResponse = resolveCommonApiResponse(res);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해 주세요.");
                    EventBus.$emit("changeStyleLoading", false);
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                // EventBus.$emit("changeStyleLoading", false);
                // location.href = '/'
                // const {status} = response || {status: null};
                // if (status === 401) {
                //     return onUnauthorized();
                // } else if (status === Errored) {
                //     alert("잘못된 정보입니다.");
                // }
                // throw Error(response);
            });
    },

    getStatistics(path, params = null) {
        return axios
            .get(`${statisticsURL + path}`, {params: params})
            .then((res) => {
                return resolveCommonApiResponse(res);
            })
            .catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                return response;
            })
    },
    postStatistics(path, data) {
        return axios
            .post(`${statisticsURL + path}`, data)
            .then((res) => {
                return resolveCommonApiResponse(res);
            })
            .catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                return response;
            })
    },

    encodeVideo(data) {
        let config = {
            headers: {
                "Content-Type": `application/json`,
                Authorization: "",
            },
        };
        return axios
            .post(videoEncodeApi, JSON.stringify(data), config)
            .then((res) => {
                const handledResponse = resolveCommonApiResponse(res);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    return res;
                } else {
                    if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                        logout();
                    } else {
                        EventBus.$emit("resetLogoutTimer", true);
                        return res;
                    }
                }
            })
            .catch((error) => {
                const {response} = error;
                const handledResponse = resolveCommonApiError(response);
                if (handledResponse === stopHandledResponseFlow) {
                    return handledResponse;
                }
                logApiError(error);
                const {status} = response || {status: null};
                if (status === 400 || status === 401) {
                    return onUnauthorized();
                } else if (status != null) {
                    alert("잘못된 정보입니다.");
                }
                let result = getResultDefaultData(status);
                //throw Error(response)
                return result;
            });
    },
    getStatisticsJava(path, params = null) {
        return axios.get(`${statisticsJavaURL + path}`, {params: params}).then((res) => {
            return resolveCommonApiResponse(res);
        }).catch((error) => {
            const {response} = error;
            const handledResponse = resolveCommonApiError(response);
            if (handledResponse === stopHandledResponseFlow) {
                return handledResponse;
            }
            logApiError(error);
        });
    },
    postStatisticsJava(path, data) {
        return axios.post(`${statisticsJavaURL + path}`, data).then((res) => {
            return resolveCommonApiResponse(res);
        }).catch((error) => {
            const {response} = error;
            const handledResponse = resolveCommonApiError(response);
            if (handledResponse === stopHandledResponseFlow) {
                return handledResponse;
            }
            logApiError(error);
        });
    },
    putStatisticsJava(path, data) {
        return axios.put(`${statisticsJavaURL + path}`, data).then((res) => {
            return resolveCommonApiResponse(res);
        }).catch((error) => {
            const {response} = error;
            const handledResponse = resolveCommonApiError(response);
            if (handledResponse === stopHandledResponseFlow) {
                return handledResponse;
            }
            logApiError(error);
        });
    },
    deleteStatisticsJava(path, data) {
        return axios.delete(`${statisticsJavaURL + path}`, {data: data}).then((res) => {
            return resolveCommonApiResponse(res);
        }).catch((error) => {
            const {response} = error;
            const handledResponse = resolveCommonApiError(response);
            if (handledResponse === stopHandledResponseFlow) {
                return handledResponse;
            }
            logApiError(error);
        });
    },
};
